import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const agendaTimezone = (value) => {
    const candidate = value || Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Lisbon';
    try { new Intl.DateTimeFormat('en', { timeZone: candidate }); return candidate; }
    catch { return 'Europe/Lisbon'; }
};

export const getAgendaBounds = (range, zone) => ({
    timestamp: dayjs.tz(range.start, zone).toISOString(),
    endTimestamp: dayjs
        .tz(dayjs(range.end).add(1, 'day').format('YYYY-MM-DD'), zone)
        .toISOString()
});

export const normalizePatientName = (name) =>
    String(name || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();

export const groupAppointments = (appointments, search, range, zone) => {
    const groups = new Map();
    const term = normalizePatientName(search);
    [...appointments]
        .sort((a, b) => dayjs(a.ts).valueOf() - dayjs(b.ts).valueOf())
        .forEach((appointment) => {
            const date = dayjs(appointment.ts).tz(zone).format('YYYY-MM-DD');
            if (
                date < range.start ||
                date > range.end ||
                !normalizePatientName(appointment.patient?.name).includes(term)
            )
                return;
            if (!groups.has(date)) groups.set(date, []);
            groups.get(date).push(appointment);
        });
    return [...groups.entries()];
};
